<template>
    <div style="padding-top: 1rem">
        <!--<navTitle title="提交充值申请" path="/user" :ask="true"></navTitle>-->
        <navTitle :title="
        $router.app._route.query.ti
          ? $router.app._route.query.ti
          : 'Kirim aplikasi top up'
      " path="/user"></navTitle>

        <div class="isnull" v-if="showTips==='true'">
            Anda dapat top up setelah mengikat rekening bank (akun yang salah tidak dapat diubah)
            <div class="isnull-btn" @click="$router.push({ path: '/user/myPay' })">
                Bind bank
            </div>
        </div>


        <div class="game-tips" v-if="frist_money>0">
            Top up Rp50.000 pertama kali dan dapat hadiah {{icon_moeny }}{{frist_money | MoneyFormat}}
            <!-- Pertama kali top up berapapun mendapatkan{{icon_moeny }}{{frist_money | MoneyFormat}} -->
        </div>

        <div class="recharge">
            <div class="gift-container" v-if="recharge_gift_is_open">
                <div class="box" v-for="(v, k) in recharge_gift_list" :key="k">
                    <img v-if="v.is_get" src="../../assets/images/g3.png" @click="receiveGift()">
                    <img v-else :src="require(`../../assets/images/g${k}.png`)" @click="receiveGift()">
                </div>
            </div>

            <div class="nav acea-row row-around row-middle">
                <div class="item on">
                    Pilih jumlah TOP-UP
                </div>
            </div>

            <p class="switch-info">Silakan pilih jumlah dan lanjutkan</p>
            <div class="info-wrapper">
                <div class="money-switch">
                    <div v-if="first_gift_amount_flag">
                        <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                             v-for="(item,index) in money_switch"
                             v-key="index" @click="switchItem(item,index)">{{icon_moeny}}
                            {{item | MoneyFormat}}
                            <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                <label v-else>---</label>
                            </div>
                        </div>
                    </div>
                    <div v-else class="switch-item" :class="switch_index==index?'switch-click':''"
                         v-for="(item,index) in money_switch"
                         v-key="index" @click="switchItem(item,index)">{{icon_moeny}}
                        {{item | MoneyFormat}}
                    </div>
                </div>

                <div class="tips" v-if="!active">
                    Catatan: Saldo saat ini<span>{{icon_moeny}}{{ now_money || 0 | MoneyFormat  }}</span>
                </div>
                <div class="tips" v-else>
                    Catatan: Saldo saat ini<span>{{icon_moeny}}{{ now_money  || 0  | MoneyFormat}}</span>
                </div>
                <div class="pay-btn bg-color-blue" @click="recharge">
                    Konfirmasi TOP-UP
                </div>
            </div>
        </div>
        <div class="list" v-if="showTips === 'false' && applyList.length > 0">
            <div class="title">Catatan TOP-UP</div>
            <div class="li" v-for="item in applyList">
                <div class="row">Nomor pesanan:{{ item.order_id }}</div>
                <div class="row">Waktu aplikasi:{{ item.add_time }}</div>
                <div class="row">Jumlah TOP-UP:{{ item.price | MoneyFormat }}</div>
                <div class="row">
                    Status TOP-UP:
                    <span v-if="item.state == 0">Reviewing</span>
                    <span v-if="item.state == 1" style="color: #40B883">Sukses</span>
                    <span v-if="item.state == 2" style="color: #dd3823">Application failed</span>
                </div>
            </div>
        </div>
        <!--点击礼物弹窗-->
        <div v-if="r_d_pop">
            <div id="forPop" @click="bgClose"></div>
            <div class="all-award-list">
                <div class="rule">
                    ⓘJumlah pengisian ulang yang berhasil ke-{{recharge_gift_list[0].view}},
                    ke-{{recharge_gift_list[1].view}}, dan ke-{{recharge_gift_list[2].view}} dapat digandakan
                    masing-masing sebesar {{recharge_gift_list[0].multiple}},{{recharge_gift_list[1].multiple}} dan
                    {{recharge_gift_list[2].multiple}} kali. Jika Anda menang, Anda bisa menerima jumlah dua kali lipat
                    dalam daftar berikut.

                    <!--                    第{{n1.view}},{{n2.view}},{{n3.view}}笔充值成功的金额分别可以翻{{n1.multiple}},{{n2.multiple}},{{n3.multiple}}倍,若中奖可以在下列表中领取翻倍的金额-->
                </div>
                <div class="r-title">
                    Isi Ulang Daftar Hadiah Keberuntungan <!--充值幸运大奖列表-->
                </div>
                <table style="width: 96%;border: 1px;text-align: center;margin-left: 2%;margin-bottom: 10px">
                    <tr style="background: #00c3f9;color: #fff;height: 35px">
                        <td>Jenis</td>
                        <td>Tanggal</td>
                        <td>UID</td>
                        <td>Jumlah</td>
                        <td>Beroperasi</td>
                    </tr>
                    <tr style="height: 45px;font-size: .24rem" v-for="(v,k) in r_l_list">
                        <td><img :src="require(`../../assets/images/g${k}.png`)"></td>
                        <td>{{formattedDate(v.add_time)}}</td>
                        <td>{{v.uid}}</td>
                        <td>Rp{{v.amount*v.multiple}}</td>
                        <td>
                            <div v-if="v.uid===uid">
                                <div class="re-btn" v-if="v.is_return===0"
                                     @click="receiveBtn(v.id,v.amount*v.multiple)">menerima
                                </div>
                                <div class="re-btn received" v-else>diterima</div>
                            </div>
                            <div v-else>--</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {
        recharge_info,
        recharge_apply,
        recharge_apply_list,
        withdraw_info,
        payok_create,
        getChannelUseInfo,
        getRechargeWelfare,
        getRechargeGift,
        DebounceBy,
    } from "../../api/user";

    // import {pay} from "@libs/wechat";
    import {isWeixin} from "@utils";
    // import {rechargeWechat} from "@api/user";
    // import {add, sub} from "@utils/bc";
    import navTitle from "@components/navTitle";

    export default {
        name: "Recharge",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                // navRecharge: ["账户充值", "佣金导入"],
                icon_moeny: this.global.moeny,
                navRecharge: [],
                active: 0,
                payType: ["weixin"],
                from: isWeixin() ? "weixin" : "weixinh5",
                money: "20000",
                now_money: "",
                showTips: "",
                my_cash: [],
                applyList: [],
                money_switch: [20000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000, 20000000],
                switch_index: 0,
                frist_money: 0,
                first_gift_amount_flag: false,
                gift_list: [],
                recharged_amount: [],
                r_d_pop: false,
                recharge_gift_is_open: false,
                r_l_list: [],
                recharge_gift_list: [],
                uid: '',
            };
        },
        computed: mapGetters(["userInfo"]),
        mounted: function () {
            this.now_money = this.userInfo.now_money;
            this.getList();
            this.getApplyList();
            this.getChannelUseInfo();
            this.initGifts();
        },
        watch: {
            $route(n) {
                if (n.name === "Recharge_cash") {
                    this.getList();
                    if (n.query.r == 1) {
                    }
                }
            }
        },
        methods: {
            switchItem(money, index) {
                this.money = money
                this.switch_index = index
            },
            navRecharges: function (index) {
                this.active = index;
            },
            convertToObj(arr) {
                const result = {};
                arr.forEach(item => {
                    const [amount, quantity] = item.split(",");
                    result[parseInt(amount)] = parseInt(quantity);
                });
                return result;
            },
            getQuantity(a) {
                const dataObj = this.convertToObj(this.gift_list);
                return dataObj[a] || 0;
            },
            getList() {
                this.$dialog.loading.open("Loading...");
                //查询账户是否已绑定钱包
                withdraw_info().then(res => {
                    if (null != res.data.my_cash && res.data.my_cash.bank_card != "") {
                        this.showTips = "false";
                    } else {
                        this.showTips = "true";
                    }
                });

                recharge_info()
                    .then(res => {
                        this.$dialog.loading.close();
                        this.payList = res.data.types;
                        this.my_cash = res.data.my_cash;
                        this.frist_money = res.data.first_recharge_award

                        let my_cash = res.data.my_cash;
                        if (my_cash.length > 0) {
                            my_cash.forEach(
                                item => item.type != "" && this.navRecharge.push(item.type)
                            );
                            // this.showTips = "false";
                        } else {
                            // this.showTips = "true";
                        }
                    })
                    .catch(res => {
                        this.$dialog.loading.close();
                    });
            },
            getChannelUseInfo() {
                let that = this
                getChannelUseInfo().then(res => {
                    that.gift_list = res.data.gift_prop_arr
                    that.recharged_amount = res.data.recharged_amount
                    that.first_gift_amount_flag = res.data.recharge_gift_open === 1 ? true : false
                }).catch(res => {
                    // console.log(res)
                })
            },
            getApplyList() {
                recharge_apply_list({
                    page: 1,
                    limit: 30
                }).then(res => {
                    this.applyList = res.data.list;
                });
            },
            recharge: function () {
                if (this.money > 0) {
                    // console.log('this.money ',this.money )
                    if (this.money < 20000) {
                        return this.$dialog.toast({mes: "Minimum 20.000 to top-up"});
                    }
                    this.$router.push({
                        path: "/user/pay",
                        query: {
                            m: this.money,
                        }
                    });
                    return
                    let param = {amount: this.money}
                    payok_create(param).then(res => {
                        console.log(res)
                        this.$dialog.loading.close()
                        let payinfo = res.data.res.paymentInfo
                        if (payinfo.type === 'url') {
                            window.location.href = payinfo.content
                        } else {
                            console.log(payinfo)
                            // this.pay_code = payinfo.content
                            // this.showCode = true
                        }
                    }).catch((res) => {
                        console.log(res)
                        this.$dialog.loading.close()
                        this.$dialog.error(res.data.msg)
                    })
                } else {
                    this.$dialog.toast({mes: "Please enter top up amount"});
                }
            },
            initGifts() {
                let that = this
                getRechargeWelfare().then(res => {
                    console.log(res)
                    that.uid = res.data.uid
                    that.recharge_gift_list = res.data.gift_list
                    that.r_l_list = res.data.award_list
                    that.recharge_gift_is_open = parseInt(res.data.is_open) === 1 ? true : false
                })
            },
            receiveGift() {
                this.initGifts()
                this.r_d_pop = true
                // console.log(v)
            },
            bgClose() {
                this.r_d_pop = false
            },
            formattedDate(timestamp) {
                const date = new Date(timestamp * 1000) // 乘以1000将秒转换为毫秒
                return date.toLocaleDateString() // 使用toLocaleDateString()格式化日期
                /*const year = date.getFullYear();
                const month = date.getMonth() + 1; // 月份从0开始，所以需要加1
                const day = date.getDate();
                return `${year}-${month}-${day}`;*/
            },
            receiveBtn: DebounceBy(function (id, amount) {
                const param = {id: id}
                let that = this
                that.$dialog.loading.open("loading");
                getRechargeGift(param).then(res => {
                    if (res.status === 200) {
                        that.now_money = parseInt(that.now_money) + amount
                        that.initGifts()
                        that.$dialog.loading.close()
                        that.$dialog.toast({mes: res.msg});
                    }
                }).catch(err => {
                    this.$dialog.loading.close()
                    that.$dialog.toast({mes: err.msg});
                })
            }, 3000)
        }
    };
</script>

<style scoped>
    #iframe {
        display: none;
    }

    .game-tips {
        width: 7.5rem;
        margin: 0 auto;
        height: 0.6rem;
        line-height: 0.6rem;
        background: rgba(254, 211, 44, 0.6);
        color: #333;
        position: fixed;
        text-align: center;
        top: 1rem;
        left: 0px;
        right: 0px;
        z-index: 10;
        font-size: 0.25rem;
    }

    .recharge {
        width: 7.03rem;
        padding: 0.5rem 0.33rem 0.45rem 0.33rem;
        background-color: #fff;
        margin: 0.2rem auto 0 auto;
        border-radius: 0.1rem;
    }

    .recharge .nav {
        height: 0.75rem;
        line-height: 0.75rem;
        /*padding: 0 1rem;*/
        margin-bottom: .2rem;
    }

    .recharge .nav .item {
        font-size: 0.3rem;
        color: #333;
    }

    .recharge .nav .item.on {
        font-weight: bold;
        border-bottom: 0.04rem solid #00c3f9;
    }

    .recharge .info-wrapper {
        text-align: center;
    }

    .recharge .info-wrapper .money {
        margin-top: 0.6rem;
        padding-bottom: 0.2rem;
        border-bottom: 1px dashed #ddd;
    }

    .recharge .info-wrapper .money span {
        font-size: 0.56rem;
        color: #333;
        font-weight: bold;
    }

    .recharge .info-wrapper .money input {
        display: inline-block;
        width: 3rem;
        font-size: 0.84rem;
        text-align: center;
        color: #282828;
        font-weight: bold;
        padding-right: 0.7rem;
    }

    .recharge .info-wrapper .money input::placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-webkit-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-ms-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .tips {
        font-size: 0.26rem;
        color: #888;
        margin: 0.25rem auto 0 auto;
        line-height: 1.5;
        padding: 0 0.3rem;
    }

    .recharge .info-wrapper .tips span {
        color: #ef4a49;
    }

    .recharge .info-wrapper .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .list {
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        background: #fff;
    }

    .list .title {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.3rem;
        border-bottom: 2px solid #00c3f9;
        text-align: center;
    }

    .list .li {
        margin-bottom: 0.15rem;
        border-bottom: 1px dashed #ccc;
        margin-top: 0.15rem;
    }

    .list .li {
        padding: 0.15rem 0;
    }

    .list .li .row {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    /*.money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    }*/


    .money-switch .switch-item {
        width: 50%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        color: #333;
        font-size: 0.36rem;
        transform: scale(0.9);
    }

    .money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        /*flex-direction: row;*/
        /*justify-content: space-between;*/
    }

    .money-switch .switch-item1 {
        width: 45%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 25px;
        color: #333;
        font-size: 0.36rem;
        margin-left: 2.5%;
        float: left;
    }

    .money-switch .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .money-switch .switch-item1:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .switch-info {
        margin-bottom: 10px;
        color: #666;
        /*text-align: center;*/
    }

    .gift-amount {
        width: 86%;
        margin-left: 7%;
        border-top: 1px dashed darkgrey;
        color: darkgrey;
        font-size: .3rem;
    }

    .gift-switch-click {
        font-weight: bold;
        color: goldenrod !important;

    }

    .gift-container {
        display: flex;
        justify-content: space-between;
    }

    .box {
        flex: 1;
        /*background-color: lightgray;*/
        text-align: center;
        padding: 10px;
        /*border: 1px solid gray;*/
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    #forPop1 {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .all-award-list {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        /*height: 370px;*/
        height: auto;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        /*position: fixed;*/
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
        text-align: center;
    }

    .rule {
        padding: 3px 5px;
        font-size: .24rem;
        color: orangered;
    }

    .r-title {
        font-size: .3rem;
        color: darkgrey;
        padding: 3px;
    }

    .re-btn {
        color: #fff;
        background-color: #00c3f9;
        padding: 3px 1px;
        border-radius: 3px;
    }

    .received {
        background-color: darkgrey;
    }
</style>